import type { Receipt } from "@/api/types";
import { receiptFallbackLabel } from "./format";

/**
 * True when a receipt has no photo origin (ADR-0031). Drives the frontend-only
 * affordances: hide the photo slot / confirm CTA / re-parse / «фото видалено»
 * marker, and render the neutral «Вручну» badge. A legacy receipt with `source`
 * absent is treated as a photo receipt (backend serves absent as `photo`).
 */
export function isManualReceipt(r: Pick<Receipt, "source">): boolean {
  return r.source === "manual";
}

/**
 * Receipt display label. Per openapi v0.3.2:
 *   - vendor_name wins when non-null;
 *   - fallback is the "Чек DD.MM" date-based label, never `file_name`.
 */
export function receiptTitle(r: Pick<Receipt, "vendor_name" | "created_at">): string {
  if (r.vendor_name && r.vendor_name.trim() !== "") return r.vendor_name;
  return receiptFallbackLabel(r.created_at);
}
